import { IPickerOption } from '../../Pickers/Picker/types';

export enum CrumbsType {
  CRUMB = 'crumb',
  TAB = 'tab',
}

export interface ICrumb extends IPickerOption {
  counter?: number;
  error?: boolean;
}

export interface ICrumbProps {
  type?: CrumbsType;
  crumbs: ICrumb[];
  activeCrumb: ICrumb['value'];
  onClick: (value: ICrumb['value']) => void;
  translateLabel?: boolean;
  roundedCounterValue?: boolean;
  withPartition?: boolean;
  crumbClassName?: string;
  counterClassName?: string;
  wrapperClassName?: string;
}
